import { z } from 'zod';

export const EventCategoryDto = z.object({
  id: z.uuid(),
  slug: z.string(),
  name: z.string(),
  icon: z.string().nullable(),
  sortOrder: z.number().int(),
  isActive: z.boolean(),
});
export type EventCategoryDto = z.infer<typeof EventCategoryDto>;

// Base field validators без .default() — общие для create и update. Дефолты
// живут только на create-инпуте: на partial-update они бы «воскрешали» значения
// (например, sortOrder → 0), молча стирая существующие значения при PATCH без этого поля.
const baseShape = {
  slug: z
    .string()
    .min(1)
    .max(64)
    .regex(/^[a-z][a-z0-9-]*$/, 'lowercase, digits, dashes'),
  name: z.string().min(1).max(120),
  icon: z.string().max(8).optional(),
  sortOrder: z.number().int().min(0).max(10_000),
  isActive: z.boolean(),
} as const;

export const EventCategoryCreateInput = z.object({
  ...baseShape,
  sortOrder: baseShape.sortOrder.default(0),
  isActive: baseShape.isActive.default(true),
});
export type EventCategoryCreateInput = z.infer<typeof EventCategoryCreateInput>;

// Partial без дефолтов: опущенное поле остаётся undefined, и сервис его не трогает.
export const EventCategoryUpdateInput = z.object(baseShape).partial();
export type EventCategoryUpdateInput = z.infer<typeof EventCategoryUpdateInput>;
